const en = {
  // Navbar
  'nav.home': 'Home',
  'nav.about': 'About Us',
  'nav.solutions': 'Our Solutions',
  'nav.sectors': 'Industries We Serve',
  'nav.contact': 'Contact',
  'nav.references': 'References',
  'nav.blog': 'Blog',
  'nav.allSectors': 'All Sectors',
  
  // Solutions
  'solutions.aiAgent': 'AI Agent',
  'solutions.aiAgent.desc': 'Autonomous decision making systems',
  'solutions.imageProcessing': 'Image Processing',
  'solutions.imageProcessing.desc': 'Object recognition and analysis',
  'solutions.decisionSupport': 'Decision Support Systems',
  'solutions.decisionSupport.desc': 'Forecasting and optimization',
  
  // Sectors
  'sectors.retail': 'Retail',
  'sectors.finance': 'Finance',
  'sectors.automotive': 'Automotive',
  'sectors.mobility': 'Mobility & Smart City',
  'sectors.energy': 'Energy',
  'sectors.service': 'Service & HR',
  'sectors.public': 'Public',
  'sectors.manufacturing': 'Manufacturing',
  'sectors.health': 'Health',
  
  // Footer
  'footer.corporate': 'Corporate',
  'footer.solutions': 'Our Solutions',
  'footer.sectors': 'Industries',
  'footer.contact': 'Contact',
  'footer.description': 'We take your business to the future with artificial intelligence and data science solutions.',
  'footer.copyright': 'Copyright © 2021 All Rights Reserved by Datafors.',
  'footer.address': 'Address',
  'footer.phone': 'Phone',
  'footer.email': 'Email',
  
  // Home Page
  'home.hero.title1': 'Transforming Data into Knowledge,',
  'home.hero.title2': 'Knowledge into Value!',
  'home.hero.subtitle': 'DATAFORS',
  
  'home.about.title': 'Datafors Artificial Intelligence Inc.',
  'home.about.p1': 'Datafors is a technology and innovation production center that provides end-to-end solutions to complex problems of public institutions, global organizations and leading companies in different sectors through image processing, mathematical optimization, decision support systems and artificial intelligence technologies.',
  'home.about.p2': 'Founded in 2016 when AI-focused startups were still limited in Turkey, Datafors began its journey with academic rigor and R&D vision. By 2020 it was formalized as Datafors Artificial Intelligence Inc. within Boğaziçi University Technopark by a core team expert in Industrial Production, IoT, Statistics, Physics and Optimization, mastering both academic literature and real sector dynamics.',
  'home.about.p3': 'Through strategic ties with the academic world and multidisciplinary research groups formed with expert academics, it designs "tailor-made" innovative solutions across a wide spectrum from Finance to Energy, Human Resources to Automotive.',
  'home.about.expertise': 'Our areas of expertise:',
  'home.about.expertise1': 'Maintaining, automating, and improving corporate decision-making processes and workflows with AI Agent Systems.',
  'home.about.expertise2': 'Real-time image analysis and recognition systems with Advanced Image Processing Technologies.',
  'home.about.expertise3': 'Data-driven management and optimization of complex processes with Intelligent Decision Support Systems.',
  'home.about.button': 'About Us',
  
  'home.competencies.title': 'Our Competencies',
  'home.competencies.statistical.title': 'Statistical Decision Support Systems',
  'home.competencies.statistical.desc': 'We develop data-driven mathematical models to minimize error risk in decision processes and increase operational efficiency.',
  'home.competencies.statistical.item1': 'Multi-dimensional data analysis',
  'home.competencies.statistical.item2': 'Forecasting models',
  'home.competencies.statistical.item3': 'Risk analysis and optimization',
  
  'home.competencies.image.title': 'Image Processing',
  'home.competencies.image.desc': 'We transform visual data into meaningful information with deep learning and computer vision technologies, developing automatic detection and classification systems.',
  'home.competencies.image.item1': 'Object recognition and detection',
  'home.competencies.image.item2': 'Face recognition systems',
  'home.competencies.image.item3': 'Quality control automation',
  
  'home.competencies.optimization.title': 'Mathematical Optimization',
  'home.competencies.optimization.desc': 'We transform complex business processes into mathematical models, optimizing resource usage and minimizing costs.',
  'home.competencies.optimization.item1': 'Route optimization',
  'home.competencies.optimization.item2': 'Resource planning',
  'home.competencies.optimization.item3': 'Production scheduling',
  
  'home.competencies.ai.title': 'Artificial Intelligence and Machine Learning',
  'home.competencies.ai.desc': 'We produce intelligent solutions to complex problems with deep learning algorithms and custom AI models.',
  'home.competencies.ai.item1': 'Natural language processing',
  'home.competencies.ai.item2': 'Predictive maintenance systems',
  'home.competencies.ai.item3': 'Anomaly detection',
  
  'home.competencies.iot.title': 'IoT and Data Integration',
  'home.competencies.iot.desc': 'We establish real-time data collection, processing and analysis systems with Internet of Things technologies.',
  'home.competencies.iot.item1': 'Sensor data collection',
  'home.competencies.iot.item2': 'Real-time monitoring',
  'home.competencies.iot.item3': 'Data integration platforms',
  
  'home.competencies.research.title': 'Academic R&D',
  'home.competencies.research.desc': 'In collaboration with universities and research institutions, we develop innovative solutions with scientific methods.',
  'home.competencies.research.item1': 'TÜBİTAK supported projects',
  'home.competencies.research.item2': 'Academic publications',
  'home.competencies.research.item3': 'Knowledge transfer',
  
  'home.why.title': 'Why Datafors?',
  'home.why.subtitle': 'With our academic excellence and industrial experience, we take your business to the future by offering data-driven solutions.',
  'home.why.academic.title': 'Academic-Based Approach',
  'home.why.academic.desc': 'Within Boğaziçi University Technopark, our solutions developed with academic rigor and scientific methods produce evidence-based and measurable results.',
  'home.why.custom.title': 'Customized Solutions',
  'home.why.custom.desc': 'We design "tailor-made" solutions specific to each institution\'s unique needs, developing systems customized for you instead of ready-made packages.',
  'home.why.measurable.title': 'Measurable Results',
  'home.why.measurable.desc': 'With our data-driven approach, we increase operational efficiency, optimize costs, and create tangible business value.',
  'home.why.expert.title': 'Expert Team',
  'home.why.expert.desc': 'With our multidisciplinary team expert in artificial intelligence, data science, optimization and image processing, we produce solutions to complex problems.',
  'home.why.button': 'More Information',
  
  'home.solutions.title': 'Our Products and Solutions',
  'home.solutions.subtitle': 'Increase your operational efficiency with our AI-powered solutions tailored to your business needs',
  'home.solutions.aiAgent.title': 'AI Agent',
  'home.solutions.aiAgent.desc': 'Increase your operational efficiency with AI agent systems that optimize autonomous decision-making and business processes.',
  'home.solutions.aiAgent.item1': 'Autonomous decision-making systems',
  'home.solutions.aiAgent.item2': 'Workflow automation',
  'home.solutions.aiAgent.item3': 'Intelligent process management',
  'home.solutions.aiAgent.button': 'Explore in Detail',
  
  'home.solutions.image.title': 'Image Processing Technologies',
  'home.solutions.image.desc': 'Advanced technology solutions that transform visual data into meaningful information with deep learning and computer vision.',
  'home.solutions.image.item1': 'Object recognition and detection',
  'home.solutions.image.item2': 'Face recognition systems',
  'home.solutions.image.item3': 'Quality control automation',
  
  'home.solutions.decision.title': 'Decision Support Systems',
  'home.solutions.decision.desc': 'Optimize your complex business processes and make strategic decisions with data-driven mathematical models.',
  'home.solutions.decision.item1': 'Forecasting models',
  'home.solutions.decision.item2': 'Risk analysis and optimization',
  'home.solutions.decision.item3': 'Strategic planning tools',
  
  'home.solutions.note': 'All our solutions can be customized according to your business\'s specific needs',
  'home.solutions.contactButton': 'Contact Us',
  
  'home.sectors.title': 'Industries We Serve',
  'home.sectors.subtitle': 'We add value to leading institutions in different sectors with artificial intelligence and data science solutions',
  'home.sectors.retail.desc': 'Customer analysis, inventory optimization, and sales forecasting',
  'home.sectors.finance.desc': 'Risk analysis, fraud detection, and portfolio optimization',
  'home.sectors.automotive.desc': 'Quality control, production optimization, and predictive maintenance',
  'home.sectors.mobility.desc': 'Traffic management, route optimization, and smart transportation',
  'home.sectors.energy.desc': 'Demand forecasting, grid optimization, and energy efficiency',
  'home.sectors.service.desc': 'Talent management, performance analysis, and workforce planning',
  'home.sectors.public.desc': 'Digital transformation, data analysis, and smart city solutions',
  'home.sectors.manufacturing.desc': 'Production optimization, quality control, and predictive maintenance',
  
  // About Page
  'about.hero.title': 'About Us',
  'about.who.title': 'Who We Are?',
  'about.who.p1': 'Datafors is a technology and innovation production center that provides end-to-end solutions to complex problems of public institutions, global organizations and leading companies in different sectors through image processing, mathematical optimization, decision support systems and artificial intelligence technologies.',
  'about.who.p2': 'Founded in 2016 when AI-focused startups were still limited in Turkey, Datafors began its journey with academic rigor and R&D vision. By 2020 it was formalized as Datafors Artificial Intelligence Inc. within Boğaziçi University Technopark by a core team expert in Industrial Production, IoT, Statistics, Physics and Optimization, mastering both academic literature and real sector dynamics.',
  'about.who.p3': 'Through strategic ties with the academic world and multidisciplinary research groups formed with expert academics, it designs "tailor-made" innovative solutions across a wide spectrum from Finance to Energy, Human Resources to Automotive.',
  
  'about.vision.title': 'Our Vision',
  'about.vision.desc': 'To be Turkey\'s leading technology center in artificial intelligence and data science; to be a reliable solution partner in institutions\' digital transformation journey by combining academic excellence with industrial application.',
  
  'about.mission.title': 'Our Mission',
  'about.mission.desc': 'To transform complex business problems into artificial intelligence solutions that create measurable value by combining academic rigor with our sectoral experience. To develop sustainable and scalable systems specific to institutions\' unique needs with a "tailor-made" approach in every project.',
  
  'about.values.title': 'Our Values',
  'about.values.innovation.title': 'Innovation',
  'about.values.innovation.desc': 'To stay ahead of the industry and produce innovative solutions through continuous research and development.',
  'about.values.reliability.title': 'Reliability',
  'about.values.reliability.desc': 'To give confidence to our customers with academic-based approach and evidence-based solutions.',
  'about.values.collaboration.title': 'Collaboration',
  'about.values.collaboration.desc': 'To establish strong, long-term relationships with our customers and academic partners.',
  'about.values.focus.title': 'Focus',
  'about.values.focus.desc': 'To focus on producing measurable results specific to customer needs in every project.',
  'about.values.excellence.title': 'Academic Excellence',
  'about.values.excellence.desc': 'To maintain the highest quality standards with scientific method and academic rigor.',
  'about.values.development.title': 'Continuous Development',
  'about.values.development.desc': 'To constantly develop ourselves by following technology and industry trends.',
  
  'about.academic.title': 'Academic Collaborations',
  'about.academic.bogazici.title': 'Boğaziçi University',
  'about.academic.bogazici.desc': 'We operate within the Technopark and benefit from the university\'s research infrastructure and academic knowledge.',
  'about.academic.rd.title': 'R&D Projects',
  'about.academic.rd.desc': 'We conduct joint studies with TÜBİTAK-supported projects and academic research groups.',
  'about.academic.transfer.title': 'Knowledge Transfer',
  'about.academic.transfer.desc': 'We transfer the latest developments in academic literature to industrial applications.',
  
  'about.references.title': 'Our References',
  
  // Contact Page
  'contact.hero.title': 'Contact',
  'contact.hero.subtitle': 'Contact us for your projects. Our expert team will get back to you as soon as possible.',
  
  'contact.info.title': 'Contact Information',
  'contact.info.address.title': 'Address',
  'contact.info.address.line1': 'Boğaziçi University Technopark',
  'contact.info.address.line2': '2 / 5 / 202',
  'contact.info.address.line3': 'Istanbul, Turkey',
  'contact.info.phone.title': 'Phone',
  'contact.info.phone.number': '+90 216 606 22 09',
  'contact.info.email.title': 'Email',
  'contact.info.hours.title': 'Working Hours',
  'contact.info.hours.weekday': 'Monday - Friday: 09:00 - 18:00',
  'contact.info.hours.weekend': 'Saturday - Sunday: Closed',
  'contact.info.social.title': 'Social Media',
  
  'contact.form.title': 'Get in Touch',
  'contact.form.name': 'Full Name',
  'contact.form.name.placeholder': 'Your name and surname',
  'contact.form.email': 'Email',
  'contact.form.email.placeholder': 'example@email.com',
  'contact.form.phone': 'Phone',
  'contact.form.phone.placeholder': '0 (5XX) XXX XX XX',
  'contact.form.company': 'Company',
  'contact.form.company.placeholder': 'Your company name',
  'contact.form.subject': 'Subject',
  'contact.form.subject.placeholder': 'Select a subject',
  'contact.form.subject.ai': 'AI Solutions',
  'contact.form.subject.image': 'Image Processing',
  'contact.form.subject.decision': 'Decision Support Systems',
  'contact.form.subject.general': 'General Information',
  'contact.form.subject.other': 'Other',
  'contact.form.message': 'Your Message',
  'contact.form.message.placeholder': 'Write your message here... (Maximum 500 characters)',
  'contact.form.message.limit': 'Maximum 500 characters',
  'contact.form.submit': 'Send',
  'contact.form.success': 'Your message has been sent successfully! We will get back to you as soon as possible.',
  'contact.form.error': 'An error occurred. Please try again.',
  'contact.form.required': '*',
  
  'contact.map.title': 'Our Office',
  
  'contact.faq.title': 'Frequently Asked Questions',
  'contact.faq.q1': 'What is the average delivery time for projects?',
  'contact.faq.a1': 'Project durations vary depending on the scope and complexity of the project. Small-scale projects can take 2-4 weeks, medium-scale projects 2-3 months, large-scale projects 6 months or more. We provide a detailed timeline in the initial meeting.',
  'contact.faq.q2': 'Which industries do you serve?',
  'contact.faq.a2': 'We have extensive experience in retail, finance, energy, automotive, health, public, service, and manufacturing sectors. We develop solutions tailored to each sector\'s unique needs.',
  'contact.faq.q3': 'Do you provide post-project support?',
  'contact.faq.a3': 'Yes, we provide post-project technical support and maintenance for all our projects. We regularly update and improve systems to ensure smooth operation.',
  
  references: {
    title: 'Our References',
    subtitle: 'Successful projects we have carried out with Turkey\'s leading institutions and companies',
    stats: {
      projects: 'Completed Projects',
      clients: 'Corporate Clients',
      sectors: 'Different Sectors',
      satisfaction: 'Customer Satisfaction'
    },
    institutions: 'Institutions We Work With',
    successStories: {
      title: 'Success Stories',
      retail: {
        title: 'Retail Sector',
        description: 'With the demand forecasting and price optimization system we developed for one of Turkey\'s leading retail chains, a 25% reduction in inventory costs was achieved.',
        result: '25% Cost Reduction'
      },
      finance: {
        title: 'Finance Sector',
        description: 'With the image processing and OCR solution we provided to a major bank, document processing times were shortened by 70% and error rate decreased by 90%.',
        result: '70% Time Savings'
      },
      public: {
        title: 'Public Sector',
        description: 'With the AI-supported decision support system we developed for a public institution, a 40% increase in operational efficiency was achieved.',
        result: '40% Efficiency Increase'
      }
    },
    testimonials: {
      title: 'What Our Customers Say',
      testimonial1: {
        name: 'Ahmet Yılmaz',
        position: 'CTO, Retail Company',
        text: 'Working with the Datafors team was a great experience. Thanks to their academic approach and sectoral experience, they produced practical and effective solutions for our complex problems. Especially our demand forecasting system completely changed our business.'
      },
      testimonial2: {
        name: 'Ayşe Demir',
        position: 'Digital Transformation Manager, Finance',
        text: 'Image processing and OCR solutions accelerated our operations and minimized error rates. Datafors\' technical expertise and customer-focused approach played a critical role in the project\'s success.'
      }
    },
    cta: {
      title: 'Be Part of Our Success Story',
      description: 'Take your business to the next level with our artificial intelligence and data science solutions. Our expert team is ready to design the most suitable solution for you.',
      button: 'Contact Us'
    }
  },
  
  decisionSupport: {
    hero: {
      title: 'Decision Support Systems',
      subtitle: 'Compare Alternative Actions with Measurable Results'
    },
    intro: 'Decision support systems go beyond reporting by comparing alternative actions with measurable results. In academic literature, AI-based decision support is addressed with governance, ethics, transparency dimensions as well as technical accuracy.',
    solutions: {
      title: 'Our Solutions',
      investment: {
        title: 'Investment Optimization & Incentive Simulation',
        subtitle: 'Measuring the transformation of investment into added value and determining the optimal combination of public incentives',
        scope: 'Scope',
        question1: '"Which province/region is more advantageous for this investment?"',
        question2: '"Which incentive scheme is more suitable for the investment and under what conditions?"',
        question3: '"How much does the incentive effect improve cash flow and return?"',
        question4: '"If my budget is limited, which investment item creates value first?"',
        deliverable1: {
          title: 'Incentive Eligibility Simulation',
          desc: 'Incentive eligibility analysis and scope simulation by region-sector-investment subject breakdown'
        },
        deliverable2: {
          title: 'Added Value Conversion Report',
          desc: 'Investment → capacity/efficiency/quality → added value chain analysis'
        },
        deliverable3: {
          title: 'Financial Return Set',
          desc: 'ROI, NPV, IRR, payback calculations (with/without incentive comparison)'
        },
        deliverable4: {
          title: 'Investment Portfolio Prioritization',
          desc: 'Ranking of items with highest impact under budget and schedule constraints'
        },
        deliverable5: {
          title: 'Risk & Sensitivity Analysis',
          desc: 'Variables that most affect the result and risk mitigation recommendations'
        },
        deliverable6: {
          title: 'Implementation Roadmap',
          desc: 'Document preparation, schedule, checkpoints and action plan'
        },
        benefits: 'Benefits',
        benefit1: 'Maximum benefit from incentives',
        benefit2: 'Investment decision accelerates',
        benefit3: 'Capital efficiency increases',
        benefit4: 'Cash flow more secure',
        benefit5: 'Compliance with public logic',
        benefit6: 'Applicability increases'
      },
      demand: {
        title: 'Demand Forecasting & Price Optimization',
        subtitle: 'Growing without disrupting the stock-service level-margin balance',
        scope: 'Scope',
        item1: 'SKU/store/channel based forecasting (seasonality, campaign, price effect, stock-outs)',
        item2: 'Price recommendation under constraints (margin target, competition, stock, supply, shelf life)',
        item3: 'Campaign simulation: "discount depth × duration × stock" effect',
        deliverable1: {
          title: 'Forecast Outputs',
          desc: 'SKU × store × day/week based sales forecast + confidence interval (uncertainty band)'
        },
        deliverable2: {
          title: 'Price Recommendations',
          desc: 'Recommended price by product, expected volume effect, expected margin effect'
        },
        deliverable3: {
          title: 'Campaign Simulation',
          desc: 'Campaign scenarios (price/discount/duration) and expected revenue-margin-stock effect'
        },
        deliverable4: {
          title: 'Order Recommendations',
          desc: 'Forecast based recommended order quantity and stock targets'
        },
        deliverable5: {
          title: 'Alerts',
          desc: 'Stock-out risk, excess stock risk, anomaly/suspicious demand spike, campaign deviations'
        },
        deliverable6: {
          title: 'Dashboard & API',
          desc: 'Management panel + service endpoints for ERP/POS integration'
        },
        benefits: 'Benefits',
        benefit1: 'Stock-out decreases, service level increases',
        benefit2: 'Excess stock and waste decrease',
        benefit3: 'Margin optimization',
        benefit4: 'Campaign efficiency increases',
        benefit5: 'Supply and operation plan improves',
        benefit6: 'Adaptation to competition and market dynamics'
      },
      energy: {
        title: 'Energy Transmission & Capacity Optimization',
        subtitle: 'Managing reliability and cost targets together',
        scope: 'Scope',
        item1: 'Capacity planning with demand/production forecast',
        item2: 'Operation scenarios under grid/operation constraints',
        item3: 'Critical asset & maintenance prioritization',
        deliverable1: {
          title: 'Demand / Load Forecast',
          desc: 'Short-medium term load forecasts by region/transformer center/line + uncertainty band'
        },
        deliverable2: {
          title: 'Capacity Plan',
          desc: 'Power increase, new line/transformer investment, reactive power improvement options'
        },
        deliverable3: {
          title: 'Operation Optimization',
          desc: 'Recommended operation/distribution plans under constraints (thermal limits, voltage limits, N-1)'
        },
        deliverable4: {
          title: 'Loss-Leakage Reports',
          desc: 'Technical loss analysis and mitigation actions'
        },
        deliverable5: {
          title: 'Asset Health & Maintenance',
          desc: 'Failure risk, critical impact, maintenance cost prioritization lists'
        },
        deliverable6: {
          title: 'Early Warnings',
          desc: 'Overload, voltage deviation, critical equipment risk, bottleneck points'
        },
        benefits: 'Benefits',
        benefit1: 'Reduces outage risk',
        benefit2: 'Clarifies investment return',
        benefit3: 'Reduces operating cost',
        benefit4: 'Extends asset life',
        benefit5: 'Improves planning accuracy',
        benefit6: 'Eases regulation and reporting compliance'
      }
    },
    cta: {
      title: 'Learn More About Our Decision Support Systems',
      subtitle: 'Grow your business with data-driven decisions',
      button: 'Get in Touch'
    }
  },
  
  imageProcessing: {
    hero: {
      title: 'Image Processing Solutions',
      subtitle: 'Intelligent Systems that Transform Visual Data into KPIs'
    },
    intro: 'The most expensive problems in operations are usually "late detected" situations. Our image processing solutions make security, quality and efficiency measurable by converting camera and visual document data into KPIs.',
    capabilities: {
      title: 'Our Capabilities',
      faceRecognition: {
        title: 'Face Recognition / Biometric Verification',
        desc: 'Authorization, access control, field identity verification solutions. Secure and compliant systems with GDPR-focused design.'
      },
      plateRecognition: {
        title: 'License Plate Recognition',
        desc: 'Automatic recognition and recording of vehicle license plates. Real-time plate reading solutions for parking management, security checkpoints, and traffic monitoring systems.'
      },
      sceneUnderstanding: {
        title: 'Scene Understanding',
        desc: 'Operational security and efficiency through crowd density, queue analysis, hazardous area violation, and incident detection.'
      },
      objectRecognition: {
        title: 'Object Recognition & Tracking',
        desc: 'Real-time monitoring systems for person/vehicle/equipment tracking, counting, security, and occupational health scenarios.'
      },
      ocr: {
        title: 'OCR (Intelligent Document Processing)',
        desc: 'Digital transformation through field extraction from invoices/waybills/forms, validation and automatic ERP recording.'
      },
      analysis3d: {
        title: '3D Analysis',
        desc: 'Depth-based measurement, volume/distance calculation, placement verification, and quality inspection solutions.'
      },
      syntheticImage: {
        title: 'Synthetic Image & Image Enhancement',
        desc: 'Enhancement in low light/blur conditions; model robustness with synthetic data in data scarcity.'
      },
      satelliteAnalysis: {
        title: 'Satellite Image Analysis',
        desc: 'Data extraction from satellite images and future prediction generation for urban development, land use, change detection, environmental monitoring, and agricultural analysis.'
      },
      videoAnalysis: {
        title: 'Video Image Analysis',
        desc: 'Motion analysis, event detection, behavior recognition, and automatic alarm systems from real-time video streams.'
      }
    },
    sectoral: {
      title: 'Sectoral Applications',
      retail: {
        title: 'Retail',
        desc: 'Customer experience optimization through queue analysis and density tracking'
      },
      service: {
        title: 'Service & Facility Management',
        desc: 'Field security and occupational health inspection'
      },
      manufacturing: {
        title: 'Manufacturinging',
        desc: 'Quality control and defect detection systems'
      },
      public: {
        title: 'Public',
        desc: 'Security and order maintenance applications'
      },
      health: {
        title: 'Health',
        desc: 'Document automation and patient tracking systems'
      },
      logistics: {
        title: 'Logistics',
        desc: 'Vehicle and cargo tracking, warehouse management'
      }
    },
    cta: {
      title: 'Learn More About Our Image Processing Solutions',
      subtitle: 'Optimize your operations with visual data',
      button: 'Get in Touch'
    }
  },
  
  allSectors: {
    hero: {
      title: 'Industries We Serve',
      subtitle: 'Various sectors receive AI and data science solutions from us'
    },
    intro: 'Datafors provides end-to-end solutions for complex problems across different sectors using AI, image processing, mathematical optimization and decision support systems. We develop tailor-made solutions according to each sector\'s specific needs.',
    sectors: {
      retail: {
        title: 'Retail and Digital Commerce',
        desc: 'We optimize the supply chain by understanding changing consumer behaviors. We provide precise demand forecasting, dynamic pricing and inventory optimization with machine learning.',
        feature1: 'Precise demand forecasting and inventory optimization',
        feature2: 'Dynamic pricing and promotion strategies',
        feature3: 'Customer behavior analysis and segmentation',
        button: 'Explore in Detail'
      },
      finance: {
        title: 'Finance and Banking',
        desc: 'We minimize financial risk while maximizing portfolio performance. We offer fraud detection, credit scoring and investment optimization with advanced analytics.',
        feature1: 'Risk analysis and portfolio optimization',
        feature2: 'Fraud detection and security systems',
        feature3: 'Credit scoring and customer segmentation',
        button: 'Explore in Detail'
      },
      automotive: {
        title: 'Automotive',
        desc: 'We increase quality and efficiency by optimizing production processes. We offer quality control, predictive maintenance and production planning solutions with image processing.',
        feature1: 'Quality control automation with image processing',
        feature2: 'Production optimization and scheduling',
        feature3: 'Predictive maintenance and equipment monitoring',
        button: 'Explore in Detail'
      },
      mobility: {
        title: 'Mobility and Smart City',
        desc: 'We improve traffic flow by optimizing urban transportation. We develop smart traffic management, route optimization and sustainable mobility solutions with IoT and AI.',
        feature1: 'Smart traffic management and optimization',
        feature2: 'Route planning and fleet management',
        feature3: 'IoT-based city infrastructure monitoring',
        button: 'Explore in Detail'
      },
      energy: {
        title: 'Energy',
        desc: 'We increase sustainability by optimizing energy consumption. We provide smart solutions for demand forecasting, grid optimization and renewable energy integration.',
        feature1: 'Energy demand forecasting and load balancing',
        feature2: 'Grid optimization and smart meter analysis',
        feature3: 'Renewable energy integration',
        button: 'Explore in Detail'
      },
      service: {
        title: 'Service and Human Resources',
        desc: 'We strengthen talent management by optimizing HR processes. We offer candidate matching, performance analysis and workforce planning with AI.',
        feature1: 'Talent management and candidate matching',
        feature2: 'Employee satisfaction and engagement analysis',
        feature3: 'Workforce planning and shift optimization',
        button: 'Explore in Detail'
      },
      public: {
        title: 'Public',
        desc: 'We digitize public services to increase citizen satisfaction. We provide data analysis, smart city solutions and e-government applications.',
        feature1: 'Digital transformation and e-government solutions',
        feature2: 'Data analysis and decision support systems',
        feature3: 'Smart city infrastructure management',
        button: 'Explore in Detail'
      },
      manufacturing: {
        title: 'Manufacturing and Production',
        desc: 'We maximize efficiency by optimizing production processes. We provide operational excellence with smart manufacturing, quality control automation and predictive maintenance.',
        feature1: 'Production optimization and scheduling',
        feature2: 'Quality control automation',
        feature3: 'Predictive maintenance and equipment monitoring',
        button: 'Explore in Detail'
      }
    },
    cta: {
      title: 'Sector-Specific Solutions',
      description: 'Each sector has unique needs. Datafors develops tailor-made AI and data science solutions to meet your business requirements.',
      button: 'Get in Touch'
    }
  },

  automotive: {
    hero: {
      title: 'Automotive Sector'
    },
    intro: 'In the automotive sector, we optimize production processes, provide quality control automation, and increase efficiency with predictive maintenance systems.',
    features: {
      predictive: {
        title: 'Predictive Maintenance',
        description: 'We predict equipment failures in advance with machine learning, reduce maintenance costs, and prevent production interruptions.'
      },
      fleet: {
        title: 'Fleet Management',
        description: 'We optimize vehicle fleets to reduce fuel consumption, plan routes, and increase operational efficiency.'
      },
      component: {
        title: 'Component Quality Control',
        description: 'We perform real-time quality control on production lines with image processing technologies and automatically detect defective parts.'
      }
    },
    excellence: {
      title: 'Excellence in Automotive with Datafors',
      items: [
        'Quality control automation with image processing',
        'Prevention of equipment failures with predictive maintenance',
        'Production process optimization and scheduling',
        'Supply chain management and inventory optimization',
        'Energy consumption analysis and efficiency improvement',
        'Real-time production monitoring and reporting'
      ]
    }
  },

  service: {
    hero: {
      title: 'Service Sector and Human Resources'
    },
    intro: 'We optimize talent management, increase employee satisfaction, and strengthen workforce planning with artificial intelligence and data science in human resources processes.',
    features: {
      profiling: {
        title: 'Candidate Profiling and Matching',
        description: 'With AI-powered candidate profiling, we identify the most suitable candidates for position requirements and accelerate recruitment processes.'
      },
      turnover: {
        title: 'Employee Turnover Prediction',
        description: 'We predict employee turnover with machine learning models and take proactive actions to prevent talent loss.'
      },
      competency: {
        title: 'Competency and Performance Analysis',
        description: 'We analyze employee competencies and performance to create career development plans and identify training needs.'
      }
    },
    excellence: {
      title: 'Excellence in HR Processes with Datafors',
      items: [
        'Right talent selection with data-driven recruitment decisions',
        'Employee satisfaction and engagement analysis',
        'Workforce planning and shift optimization',
        'Training needs analysis and development planning',
        'Performance evaluation systems',
        'Talent pool management and career planning'
      ]
    }
  },

  health: {
    hero: {
      title: 'Healthcare Sector',
      subtitle: 'Digital Transformation in Healthcare with Artificial Intelligence'
    },
    intro: 'In the healthcare sector, we improve patient care quality, optimize operational efficiency, and provide clinical decision support systems with artificial intelligence and data science.',
    features: {
      network: {
        title: 'Patient Tracking Systems',
        description: 'We optimize treatment processes and increase patient satisfaction with AI-powered patient tracking systems.'
      },
      frequency: {
        title: 'Medical Image Analysis',
        description: 'Automatic analysis of medical images with deep learning, providing decision support for early diagnosis and treatment planning.'
      },
      delay: {
        title: 'Predictive Analytics',
        description: 'We predict disease risks in advance by analyzing patient data and provide preventive healthcare services.'
      }
    },
    excellence: {
      title: 'Excellence in Healthcare with Datafors',
      items: [
        'Medical image analysis and automatic diagnosis support',
        'Patient tracking and appointment optimization',
        'Drug interaction and side effect prediction',
        'Hospital resource management and bed optimization',
        'Electronic health records analysis',
        'Clinical decision support systems'
      ]
    },
    applications: {
      demand: {
        title: 'Resource Optimization',
        description: 'We improve patient flow and reduce waiting times by optimizing hospital resources.'
      },
      transfer: {
        title: 'Patient Transfer',
        description: 'We optimize patient transfer processes to provide rapid response in emergency situations.'
      },
      fleetMgmt: {
        title: 'Equipment Management',
        description: 'We increase operational efficiency with maintenance and usage planning of medical equipment.'
      },
      scenario: {
        title: 'Scenario Analysis',
        description: 'We determine the most appropriate treatment plan by analyzing different treatment scenarios.'
      }
    }
  },

  aiAgent: {
    hero: {
      title: 'AI Agent Solutions',
      subtitle: 'Autonomous Decision Making and Intelligent Process Management'
    },
    intro: 'AI Agent systems go beyond automation by autonomously managing, automating and improving corporate decision-making processes and workflows. These systems increase operational efficiency while reducing human error.',
    chief: {
      title: 'Chief',
      subtitle: 'Corporate Decision Support and Workflow Automation Platform',
      button: 'Visit Chief',
      desc: 'Chief is an AI-powered platform that maintains, automates and improves corporate decision-making processes and workflows. It increases operational efficiency by managing complex business processes with autonomous decision-making capabilities.',
      features: 'Key Features',
      feature1: 'Document and data processing',
      feature2: 'Workflow automation',
      feature3: 'Task and process management',
      feature4: 'Security and authorization',
      module1: {
        title: 'Document Management',
        desc: 'Automatic classification, extraction and processing of documents'
      },
      module2: {
        title: 'Q&A System',
        desc: 'Instant answers to questions about corporate data and documents'
      },
      module3: {
        title: 'Workflow Automation',
        desc: 'Automatic execution and management of business processes'
      },
      module4: {
        title: 'Task Management',
        desc: 'Automatic assignment, tracking and reporting of tasks'
      },
      module5: {
        title: 'Alerts and Notifications',
        desc: 'Automatic alerts for critical situations and processes'
      },
      module6: {
        title: 'Reporting and Analytics',
        desc: 'Real-time performance monitoring and analysis'
      },
      module7: {
        title: 'Integration',
        desc: 'Integration with existing corporate systems'
      },
      module8: {
        title: 'Audit Trail',
        desc: 'Complete tracking and recording of all transactions'
      },
      module9: {
        title: 'Knowledge Base',
        desc: 'Corporate knowledge management and sharing'
      },
      benefits: 'Benefits',
      benefit1: 'Operational efficiency increases',
      benefit2: 'Human error decreases',
      benefit3: 'Process times shorten',
      benefit4: 'Costs decrease',
      benefit5: 'Compliance and audit facilitated'
    },
    sirdas: {
      title: 'Sırdaş',
      subtitle: 'AI-Powered Employee Support and Engagement Platform',
      button: 'Try Sırdaş',
      desc: 'Sırdaş is an AI-powered platform that increases employee satisfaction and engagement. It provides 24/7 support to employees, answers questions, and helps HR processes run more efficiently.',
      module1: {
        title: 'Employee Support',
        desc: '24/7 AI assistant answering employee questions'
      },
      module2: {
        title: 'HR Processes',
        desc: 'Automation of leave, expense and other HR processes'
      },
      module3: {
        title: 'Satisfaction Analysis',
        desc: 'Employee satisfaction and engagement measurement'
      },
      module4: {
        title: 'Suggestions and Feedback',
        desc: 'Collection and analysis of employee suggestions'
      },
      module5: {
        title: 'Confidentiality',
        desc: 'Secure and confidential communication'
      },
      module6: {
        title: 'Notifications',
        desc: 'Important announcements and reminders'
      },
      benefits: 'Benefits',
      benefit1: 'Employee satisfaction increases',
      benefit2: 'HR workload decreases',
      benefit3: 'Response times shorten',
      benefit4: 'Communication improves',
      benefit5: 'Feedback collection becomes easier',
      benefit6: 'Employee engagement increases'
    },
    cta: {
      title: 'Learn More About Our AI Agent Solutions',
      subtitle: 'Optimize your business processes with autonomous decision-making systems',
      button: 'Get in Touch'
    }
  },

  blog: {
    title: 'Blog',
    subtitle: 'Latest developments in artificial intelligence and data science',
    readMore: 'Read More',
    readTime: 'min read',
    allCategories: 'All Categories',
    categories: 'Categories',
    categoryAI: 'Artificial Intelligence',
    categoryVision: 'Image Processing',
    categoryDecision: 'Decision Support',
    categorySector: 'Sectoral',
    newsletterTitle: 'Subscribe to Our Newsletter',
    newsletterSubtitle: 'Get the latest news and updates about AI and technology',
    emailPlaceholder: 'Your email address',
    subscribe: 'Subscribe',
    posts: {
      post1: {
        title: 'The Future of Artificial Intelligence in Business',
        excerpt: 'Artificial intelligence is revolutionizing business processes. In this article, we examine how AI technologies transform business models and increase efficiency.',
        date: 'March 15, 2024',
        category: 'Artificial Intelligence'
      },
      post2: {
        title: 'Image Processing and Quality Control',
        excerpt: 'Image processing and deep learning technologies accelerate quality control processes and minimize error rates in production.',
        date: 'March 10, 2024',
        category: 'Image Processing'
      },
      post3: {
        title: 'Data-Driven Decision Support Systems',
        excerpt: 'Decision support systems supported by data analytics enable businesses to make more informed and strategic decisions.',
        date: 'March 5, 2024',
        category: 'Decision Support'
      },
      post4: {
        title: 'AI Applications in Retail',
        excerpt: 'Artificial intelligence applications in the retail sector optimize demand forecasting, inventory management, and customer experience.',
        date: 'February 28, 2024',
        category: 'Sectoral'
      },
      post5: {
        title: 'Digital Transformation in Energy',
        excerpt: 'Digital transformation in the energy sector increases operational efficiency and improves sustainability with AI-supported solutions.',
        date: 'February 20, 2024',
        category: 'Sectoral'
      },
      post6: {
        title: 'OCR and Document Processing',
        excerpt: 'Optical character recognition and intelligent document processing technologies accelerate institutions\' digital transformation processes.',
        date: 'February 15, 2024',
        category: 'Image Processing'
      }
    }
  },

  finance: {
    hero: {
      title: 'Finance Sector',
      subtitle: 'Data-Driven Financial Intelligence and Risk Management'
    },
    intro: 'In the finance sector, we minimize financial risk while maximizing portfolio performance. We offer fraud detection, credit scoring and investment optimization with advanced analytics.',
    features: {
      scenario: {
        title: 'Scenario Analysis & Stress Testing',
        description: 'We predict portfolio performance under different market conditions with machine learning models and develop risk mitigation strategies.'
      },
      anomaly: {
        title: 'Anomaly Detection & Fraud Prevention',
        description: 'We detect suspicious transactions in real-time with AI-powered systems and prevent fraud.'
      },
      portfolio: {
        title: 'Portfolio Optimization',
        description: 'We optimize asset allocation to maximize return while minimizing risk and create dynamic investment strategies.'
      }
    },
    excellence: {
      title: 'Excellence in Finance with Datafors',
      items: [
        'Risk analysis and portfolio optimization',
        'Real-time fraud detection and prevention',
        'Credit scoring and customer segmentation',
        'Market trend analysis and forecasting',
        'Regulatory compliance and reporting automation',
        'Investment strategy optimization'
      ]
    },
    applications: {
      credit: {
        title: 'Credit Risk Assessment',
        description: 'AI-powered credit scoring models for accurate risk assessment and loan approval decisions.'
      },
      market: {
        title: 'Market Analysis',
        description: 'Real-time market trend analysis and predictive modeling for investment decisions.'
      },
      fraud: {
        title: 'Fraud Detection',
        description: 'Advanced anomaly detection systems to identify and prevent fraudulent transactions.'
      },
      liquidity: {
        title: 'Liquidity Management',
        description: 'Optimize cash flow and liquidity with predictive analytics and forecasting models.'
      }
    }
  },

  retail: {
    hero: {
      title: 'Retail Sector',
      subtitle: 'Data-Driven Retail Solutions',
    },
    intro: 'Understand customer behavior, optimize inventory management, and increase sales with artificial intelligence and data analytics in the retail sector. Datafors provides competitive advantage by offering specialized solutions for retail businesses.',
    features: {
      demand: {
        title: 'Demand Forecasting and Stock Optimization',
        description: 'Predict future demand by analyzing historical sales data and market trends. Reduce costs and increase customer satisfaction by optimizing stock levels.',
      },
      pricing: {
        title: 'Dynamic Pricing',
        description: 'Perform automatic price optimization based on competitive analysis, demand elasticity, and inventory status. Maximize profitability while maintaining market share.',
      },
      inventory: {
        title: 'Smart Inventory Management',
        description: 'Reduce inventory costs, optimize shelf life, and minimize waste rates with AI-powered inventory management.',
      },
    },
    why: {
      title: 'Why Datafors?',
      reasons: {
        behavior: 'Personalized shopping experience with customer behavior analysis',
        supply: 'Operational efficiency with supply chain optimization',
        cost: 'Cost reduction and profitability increase',
        profitability: 'Sustainable growth with data-driven decisions',
      },
    },
    applications: {
      title: 'Application Areas',
      list: {
        assortment: {
          title: 'Product Assortment Optimization',
          description: 'Optimize product variety according to customer preferences',
        },
        promotion: {
          title: 'Promotion Effectiveness',
          description: 'Analyze and optimize campaign performance',
        },
        segmentation: {
          title: 'Customer Segmentation',
          description: 'Develop targeted marketing strategies',
        },
        supply: {
          title: 'Supply Chain Optimization',
          description: 'Improve logistics processes and reduce costs',
        },
      },
    },
  },

  energy: {
    hero: {
      title: 'Energy Sector',
      subtitle: 'Smart Energy Management and Optimization'
    },
    intro: 'In the energy sector, we increase sustainability by optimizing consumption. We provide smart solutions for demand forecasting, grid optimization and renewable energy integration.',
    features: {
      forecast: {
        title: 'Energy Demand Forecasting',
        description: 'We predict energy demand in advance with machine learning and optimize production and distribution planning.'
      },
      grid: {
        title: 'Grid Optimization',
        description: 'We optimize energy distribution with smart grid management and minimize losses.'
      },
      renewable: {
        title: 'Renewable Energy Integration',
        description: 'We increase sustainability by optimizing the integration of renewable energy sources into the grid.'
      }
    },
    excellence: {
      title: 'Excellence in Energy with Datafors',
      items: [
        'Energy demand forecasting and load balancing',
        'Grid optimization and smart meter analysis',
        'Renewable energy integration',
        'Predictive maintenance and equipment monitoring',
        'Energy efficiency analysis',
        'Real-time monitoring and reporting'
      ]
    }
  },

  manufacturing: {
    hero: {
      title: 'Manufacturing Sector',
      subtitle: 'Smart Manufacturing and Operational Excellence'
    },
    intro: 'We maximize efficiency by optimizing production processes. We provide operational excellence with smart manufacturing, quality control automation, and predictive maintenance.',
    features: {
      scheduling: {
        title: 'Production Scheduling',
        description: 'We analyze production processes to increase efficiency, reduce costs, and maximize production capacity.'
      },
      quality: {
        title: 'Quality Control Automation',
        description: 'We perform real-time quality control on the production line with image processing technologies and automatically detect defective products.'
      },
      supply: {
        title: 'Supply Chain Optimization',
        description: 'We optimize the supply chain to reduce inventory costs, shorten delivery times, and increase operational efficiency.'
      }
    },
    excellence: {
      title: 'Excellence in Manufacturing with Datafors',
      items: [
        'Production optimization and scheduling',
        'Quality control automation',
        'Predictive maintenance and equipment monitoring',
        'Supply chain management',
        'Energy consumption analysis',
        'Real-time production monitoring'
      ]
    },
    applications: {
      predictive: {
        title: 'Predictive Maintenance',
        description: 'We predict equipment failures in advance with machine learning, reduce maintenance costs, and prevent production interruptions.'
      },
      planning: {
        title: 'Production Planning',
        description: 'We optimize production processes with demand forecasting and capacity planning, increasing efficiency.'
      },
      energyEff: {
        title: 'Energy Efficiency',
        description: 'We analyze energy consumption to increase efficiency, reduce costs, and ensure sustainability.'
      },
      inventory: {
        title: 'Inventory Management',
        description: 'We optimize inventory levels with smart inventory management, reduce costs, and strengthen the supply chain.'
      }
    }
  },

  public: {
    hero: {
      title: 'Public Sector',
      subtitle: 'Digital Transformation and Smart City Solutions'
    },
    intro: 'In the public sector, we increase citizen satisfaction through digital services. We improve public efficiency with data analysis, smart city solutions and e-government applications.',
    features: {
      digital: {
        title: 'Digital Transformation',
        description: 'We manage the digital transformation processes of public institutions to improve service quality and increase citizen satisfaction.'
      },
      smart: {
        title: 'Smart City Solutions',
        description: 'We establish smart city infrastructure with IoT and AI, optimizing traffic management, energy efficiency and security systems.'
      },
      data: {
        title: 'Data Analysis and Decision Support',
        description: 'We provide decision support to policy makers by analyzing public data and optimize resource allocation.'
      }
    },
    excellence: {
      title: 'Excellence in Public Sector with Datafors',
      items: [
        'Digital transformation and e-government solutions',
        'Data analysis and decision support systems',
        'Smart city infrastructure management',
        'Citizen services optimization',
        'Security and surveillance systems',
        'Resource management and planning'
      ]
    }
  },

  publicSector: {
    hero: {
      title: 'Public Sector',
      subtitle: 'Digital Transformation and Smart City Solutions'
    },
    intro: 'In the public sector, we increase citizen satisfaction through digital services. We improve public efficiency with data analysis, smart city solutions and e-government applications.',
    features: {
      digital: {
        title: 'Digital Transformation',
        description: 'We manage the digital transformation processes of public institutions to improve service quality and increase citizen satisfaction.'
      },
      smart: {
        title: 'Smart City Solutions',
        description: 'We establish smart city infrastructure with IoT and AI, optimizing traffic management, energy efficiency and security systems.'
      },
      data: {
        title: 'Data Analysis and Decision Support',
        description: 'We provide decision support to policy makers by analyzing public data and optimize resource allocation.'
      }
    },
    excellence: {
      title: 'Excellence in Public Sector with Datafors',
      items: [
        'Digital transformation and e-government solutions',
        'Data analysis and decision support systems',
        'Smart city infrastructure management',
        'Citizen services optimization',
        'Security and surveillance systems',
        'Resource management and planning'
      ]
    },
    applications: {
      transport: {
        title: 'Transportation Management',
        description: 'We optimize traffic flow with smart transportation systems and increase public transport efficiency.'
      },
      resource: {
        title: 'Resource Management',
        description: 'We provide data-driven planning and optimization solutions for effective use of public resources.'
      },
      security: {
        title: 'Security Applications',
        description: 'We increase public safety with AI-powered security systems and detect incidents in advance.'
      },
      social: {
        title: 'Social Services',
        description: 'We digitalize public services with citizen-focused social service applications.'
      }
    }
  },

  mobility: {
    hero: {
      title: 'Mobility and Smart Cities',
      subtitle: 'AI-Powered Smart Transportation and City Management',
    },
    intro: 'Our smart city and mobility solutions offer AI-powered systems across a wide spectrum, from traffic management to public transportation optimization, from autonomous vehicles to urban infrastructure management. Through real-time data analysis and predictive modeling, we help cities become more livable, sustainable, and efficient.',
    features: {
      traffic: {
        title: 'Smart Traffic Management',
        description: 'We optimize urban transportation with real-time traffic flow analysis, signalization optimization, and traffic forecasting.',
      },
      route: {
        title: 'Route Optimization',
        description: 'We provide AI-powered dynamic route planning and optimization solutions for public transportation and logistics vehicles.',
      },
      fleet: {
        title: 'Fleet Management',
        description: 'We increase operational efficiency with vehicle fleet tracking, maintenance planning, and fuel optimization.',
      }
    },
    excellence: {
      title: 'Excellence in Mobility with Datafors',
      items: [
        'Smart signalization and flow optimization with real-time traffic analysis',
        'Passenger demand forecasting and capacity planning in public transportation systems',
        'AI infrastructure and integration for autonomous vehicle systems',
        'Urban infrastructure monitoring and predictive maintenance management',
        'Energy consumption optimization and sustainable city solutions',
        'Smart parking management and urban logistics optimization',
      ],
    }
  }
};

export default en;